var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 112C86.9279 112 112 86.9279 112 56C112 25.0721 86.9279 0 56 0C25.0721 0 0 25.0721 0 56C0 86.9279 25.0721 112 56 112Z",
    fill: "#FDECE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7537 39.3333H44.116C43.3153 39.3333 42.6667 39.9818 42.6667 40.7825V71.2173C42.6667 72.018 43.3153 72.6666 44.116 72.6666H68.7537C69.5544 72.6666 70.203 72.018 70.203 71.2173V40.7825C70.203 39.9818 69.5544 39.3333 68.7537 39.3333ZM53.174 48.7535C54.1747 48.7535 54.9856 49.5644 54.9856 50.5651C54.9856 51.5659 54.1747 52.3767 53.174 52.3767C52.1733 52.3767 51.3624 51.5659 51.3624 50.5651C51.3624 49.5644 52.1733 48.7535 53.174 48.7535ZM65.7697 62.139C65.6436 62.3746 65.3979 62.5217 65.1305 62.5217H47.7392C47.4812 62.5217 47.2421 62.384 47.1124 62.1608C46.9827 61.9376 46.982 61.6622 47.1102 61.4376L50.0088 56.3651C50.1139 56.1811 50.2943 56.0521 50.5023 56.013C50.711 55.9746 50.9262 56.0267 51.0907 56.1593L54.1399 58.5992L58.7617 52.6572C58.9037 52.4738 59.1298 52.3724 59.3595 52.3775C59.5921 52.3862 59.8066 52.5057 59.9363 52.6999L65.7334 61.3956C65.8812 61.6173 65.8957 61.9028 65.7697 62.139Z",
    fill: "#F0532C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileimg);
export default __webpack_public_path__ + "static/media/profileimg.e4fb0bd603b15cce117885ac5ef485a4.svg";
export { ForwardRef as ReactComponent };